import React from 'react';
import { Link } from 'react-router-dom';

type LinkWrapperProps = {
  children: React.ReactNode;
  url: string;
  className?: string;
  target?: '_self' | '_blank';
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

const LinkWrapper = ({
 children, url, className = '', target = '_self', onClick
}: LinkWrapperProps) => (
  <Link
    to={url}
    className={className}
    target={target}
    onClick={onClick}
  >
    {children}
  </Link>
);

export default LinkWrapper;
